import React, { useContext} from "react";
import sld from "../../images/sld/Rectangle.svg";
import embLabels from "../../config/emb-labels-en.json";
import { DesignAssetContext } from "../CustomHooks/ContextApi";
import Linebar from "../../components/GRIDCONNECTED/Linebar";
import Busbar from "../../components/ReusableSvg/Busbar";
import PV from "../../components/ETOGrid/PV";
import Ats from "../../components/PVHYBRIDIZATION/Ats";
import UtilityHyd from "../../components/PVHYBRIDIZATION/UtilityHyd";
import GensetHyd from "../../components/PVHYBRIDIZATION/GensetHyd";
import EccHyd from "../../components/PVHYBRIDIZATION/EccHyd";
import LoadHyd from "../../components/PVHYBRIDIZATION/LoadHyd";

const GensetPvHybridEto = () => {
  const { CBAssetList, CBLoadList, CBEVList, sldLoadCompleted,switchboardType, siteType } =
    useContext(DesignAssetContext);
    const PV1AssetData = CBAssetList[3];
    const PV2AssetData = CBAssetList[4];
    const PV3AssetData = CBAssetList[5];
    
   
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
    >
     
        <svg viewBox="0 0 1300 800" >
          <g>
            <svg x="0" y="0" viewBox="0 0 1300 800">
            <g id="grid">
              <svg>
                <image href={sld} x="0" y="0" />
              </svg>
            </g>
            <svg x={CBAssetList[5]?.uiData?.status?"-60":"5"} y="-50" >
            <g
              id="components-sld"
              style={sldLoadCompleted ? {} : { display: "none" }}
            >
              <Ats />
              <EccHyd />
             { switchboardType === embLabels?.EXISTING_SWITCHBOARD && <Linebar />}
              <Busbar secondBusbar={switchboardType === embLabels?.EXISTING_SWITCHBOARD ?true:false} />
              <UtilityHyd />
              {CBAssetList[1]?.uiData?.status && <GensetHyd />}
              {CBAssetList[3]?.uiData?.status && <PV pvIndex={3} uiData={PV1AssetData?.uiData} cbConfigData={PV1AssetData?.cbConfigData} powerMeterData={PV1AssetData?.powerMeterData} />}
              {CBAssetList[4]?.uiData?.status && <PV pvIndex={4} uiData={PV2AssetData?.uiData} cbConfigData={PV2AssetData?.cbConfigData} powerMeterData={PV2AssetData?.powerMeterData} />}
              {CBAssetList[5]?.uiData?.status && <PV pvIndex={5} uiData={PV3AssetData?.uiData} cbConfigData={PV3AssetData?.cbConfigData} powerMeterData={PV3AssetData?.powerMeterData} />}


              {CBLoadList.map((loadData, key) => (
                
                <LoadHyd
                  data = {loadData}
                  key={loadData?.uiData?.xAxis}
                  load={loadData?.uiData}
                  loadName={loadData?.configData?.name}
                  loadCbName={loadData?.cbConfigData?.name}
                  index={key}
                />
              ))}
            </g>
            </svg>
          </svg>
        </g>
      </svg>
    </div>
  );
};

export default GensetPvHybridEto;
